import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { RouteConstant } from 'src/app/core/_constants/route.constant';
import { PostPublishComponent } from 'src/app/shared/dialogs/post-publish/post-publish.component';

@Component({
  selector: 'app-mob-sidenav',
  templateUrl: './mob-sidenav.component.html',
  styleUrls: ['./mob-sidenav.component.scss']
})
export class MobSidenavComponent implements OnInit {
  show: boolean = true;
  RouteConstant:any = RouteConstant
  marketPlace:any = '/'  +RouteConstant.main + '/' + RouteConstant.marketPlaceList
  moreProfile:any = '/'  +RouteConstant.main + '/' + RouteConstant.moreProfile
  business:any = '/' +RouteConstant.business

  constructor(private router:Router,public dialogRef:MatDialog) { }

  ngOnInit(): void {
    if(window.innerWidth < 768){ 
      this.router.events
          .subscribe(
            (event:any) => {
              if(event instanceof NavigationEnd) {
                if(event.url.includes('/'  +RouteConstant.main + '/' + RouteConstant.moreProfile +  '/' + RouteConstant.addUser) || event.url.includes('/'  +RouteConstant.main + '/' + RouteConstant.moreProfile +  '/' + RouteConstant.moreChangePassword)){
                  this.show = false;
                }
                else {
                  this.show = true;
                }
              }
            });

        if(this.router.url == '/'  +RouteConstant.main + '/' + RouteConstant.moreProfile +  '/' + RouteConstant.addUser || this.router.url == '/'  +RouteConstant.main + '/' + RouteConstant.moreProfile +  '/' + RouteConstant.moreChangePassword){
          this.show = false;
        }
        else {
          this.show = true;
        }    
       
    }  
  else{  
    }
  }

  businessTab(){
    const dialogRef = this.dialogRef.open(PostPublishComponent, {
      maxHeight: '100vh',
      width: '465px',
      panelClass: 'products',
      data: {
        // img: 'assets/images/Success.png',
        heading: 'Business Tab is Coming Soon',
        // title: 'Please check your inbox and click in the recieved link to reset a password',
        btn: 'Okay'
      }

    })
  }

}
